import React, { useEffect, useState } from 'react'
import { useLoader } from '../../../Loader/LoaderContext';
import { useToaster } from '../../../Toaster/Toaster';
import { getService, postService } from '../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../api';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { PostDto, subscribe } from '../../../api/interfaces/Posts';
import { getServiceyName } from '../../../utility/RolesUtility';
import Pagination from '../usersMangmnt/Pagination';
import DateService from "../../../servce/DateService";
function Subscriber() {
  const [activeTab, setActiveTab] = useState("MONTHLY");
    const [selectedTopic, setSelectedTopic] = useState('MONTHLY');
    const location = useLocation();
      const path = location.pathname;
    const [isRefreshPage, setisRefreshPage] = useState(false)
    const [tableData, setTableData] = useState([]);
    const { showToast } = useToaster();
      const [totalPages, setTotalPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(0);
      const [searchQuery, setSearchQuery] = useState('');
      const [totalElement, setTotalElements] = useState(0);
      const { setLoading } = useLoader();
      const navigate = useNavigate();
      useEffect(() => {
        setCurrentPage(0)
        fetchVehicles();
        if (isRefreshPage) {
          fetchVehicles(); // Refresh data if triggered
          setisRefreshPage(false); // Reset the refresh trigger
        }
       
      }, [currentPage, searchQuery, isRefreshPage,activeTab]);
      const [searchParams] = useSearchParams();
        const userId = searchParams.get('appUserId');
        const name = searchParams.get('firstName')?.replace(/-/g, ' ');
      const fetchVehicles = async (name?:string) => {
        setLoading(true);
        let body: any;
      body={
        type:activeTab,
        search:searchQuery,
        page:currentPage
      }
       
        try {
          
          const response = await postService(API_ENDPOINTS.getSubscriberApi, body);
          setTableData(response.data.content);
          setTotalPages(response.data.totalPages);
          setTotalElements(response.data.totalElements)
        } catch (error) {
          showToast('error', 'error', '');
          console.error('Error fetching vehicle data:', error);
        }
        finally {
          setTimeout(() => {
            setLoading(false)
          }, 500);
        }
      };
      const handleTopicClick = (topic: string) => {
        // setserviceList(topic)
        setSelectedTopic(topic);
        fetchVehicles(topic);
      };
      const onPageChange = async (page: number) => {
        setCurrentPage(page)
      };
    
      const onNext = () => {
        if (currentPage < totalPages - 1) {
          onPageChange(currentPage + 1);
        }
      };
      const onPrevious = () => {
        if (currentPage > 0) {
          onPageChange(currentPage - 1);
        }
      };
      const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(event.target.value);
        setCurrentPage(0);
      };
      const viewPatients =() =>{
        navigate('/portals/patients/ViewPatients')
      }
      const onCopy=async ()=>{
        setLoading(true);
        try {
          
          const response = await getService(API_ENDPOINTS.getAllEmailsData+'?type='+activeTab);
          const emailList = response.data.join("\n");
      
      // Copy to clipboard
      await navigator.clipboard.writeText(emailList);
        } catch (error) {
          showToast('error', 'error', '');
          console.error('Error fetching vehicle data:', error);
        }
        finally {
          setTimeout(() => {
            setLoading(false)
          }, 500);
        }
      }
  return (
    <div className="overflow-x-auto ">
      <div className='flex items-center mb-4'>
                <h2 className='mr-2 text-gray-700 cursor-pointer font-semibold text-sm' onClick={viewPatients}>Patients</h2>
                <img src="/images/arrowIcons.svg" className="mr-2" />{" "}
                <>
                    <span className='mr-2 flex items-center'>
                        
                        <span className='text-gray-400 font-semibold text-sm mr-2'>Subscribers</span>
                        </span></>
            </div>
        <div className='flex items-center mb-3 mt-2 cursor-pointer justify-between'>
        <div className='flex items-center'>
          
          <>
          <div className='flex items-center mb-2'>
          {/* <img src='/images/back.svg' className='mr-2 cursor-pointer' onClick={viewPatients}/> */}
          <h1 className="text-2xl font-bold text-[#2D2E2F] mr-3">Subscribers</h1>
          </div>
            <div  className="relative">
            <input type='text' placeholder='Search' className='p-1.5 pl-10 border border-[#D1D5DB] w-[250px] rounded-md'  onChange={handleSearch} />
            <span className="hidden md:flex absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
    <img src='/images/search.svg' />
  </span>
            </div>
          </>
        </div>
      </div>
      <>
      <div className="border-b mb-6 mt-8 font-medium text-sm min-[1980px]:text-2xl">
        <button
          onClick={() => setActiveTab("MONTHLY")}
       
          className={`mr-6 font-semibold pb-3 border-b-2 ${activeTab === "MONTHLY" ? "text-[#B00A2B] border-[#B00A2B] " : "text-[#6B7280]  border-transparent"}`}
        >
          Monthly Subscribers
        </button>
        <button
          onClick={() => setActiveTab("WEEKLY")}
          className={`font-semibold pb-3 border-b-2 ${activeTab === "WEEKLY" ? "text-[#B00A2B] border-[#B00A2B] " : "text-[#6B7280]  border-transparent"}`}
        >
        Weekly Subscribers
        </button>
      </div>
      
        </>
    <table className="min-w-full bg-white border border-gray-200 ">
      <thead className="bg-white text-left">
        <tr>
          <th className="px-4 py-3 border-b text-gray-900 font-semibold text-base sticky bg-gray-100 left-0 z-10">Name</th>
          <th className="px-4 py-3 border-b text-gray-900 font-semibold text-base  bg-gray-100 left-0 z-10 flex items-center">Email 
            {/* <span onClick={onCopy}><img src='/images/copyIcon.svg'  className='ml-2 cursor-pointer'/></span> */}
            </th>
         
        </tr>
      </thead>
      <tbody>
        {tableData.map((user: subscribe, index: number) => (
          <tr key={0}>
            <td className="px-4 py-3 border-b text-sm text-gray-900 font-semibold sticky left-0 bg-white z-10 " >
                <span className=' line-clamp-1'>{user?.firstName} {user?.lastName} {!user?.firstName && !user?.lastName ? 'NA':''}</span>
            </td>
            <td className="px-4 py-3 border-b text-sm text-gray-900 font-semibold sticky left-0 bg-white z-10 " >
                <span className=' line-clamp-1'>{user?.email || 'NA'}</span>
            </td>
           
            
          </tr>
         ))} 
      </tbody>

    </table>
       {!tableData?.length &&
        <div className="px-3.5 md:px-20 py-8 text-center">
        <div className='text-center'>
<div className='flex justify-center'>
<img src='/images/emptyData.svg'  alt='' />
</div>
<p className='text-[#667085] text-[24px] font-semibold mt-5'>No Data Found</p>
</div>
       </div>
       }
    {
      totalPages > 1 &&
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalElement={totalElement}
        onPageChange={onPageChange}
        onNext={onNext}
        onPrevious={onPrevious}
      />
     }
  </div>
  )
}

export default Subscriber
